// TODO: need to fix swag for generate enum
export enum InvoiceTemplateType {
    InvoiceTemplateSingleLine = 'InvoiceTemplateSingleLine',
    InvoiceTemplateMultiLine = 'InvoiceTemplateMultiLine',
}
